import { translateLegacyContent, translateLegacyValue } from './legacyContent';

const DEFAULT_FIELD_BASES = [
  'name',
  'label',
  'title',
  'description',
  'summary',
  'prompt',
  'question',
  'category',
  'speciality',
  'specialty',
  'service_name',
  'zone_name',
  'clinic_name',
  'services_description',
  'provider_type',
  'booking_summary',
  'mode',
  'status',
];

export function getLocalizedField(record, baseField, language = 'fr') {
  if (!record) return null;

  const localizedKey = `${baseField}_${language}`;
  const fallbackKey = `${baseField}_fr`;

  if (record[localizedKey]) return record[localizedKey];
  if (language === 'en' && record[`${baseField}_en`]) return record[`${baseField}_en`];
  if (record[baseField]) return translateLegacyContent(record[baseField], language);
  if (record[fallbackKey]) return translateLegacyContent(record[fallbackKey], language);

  return null;
}

function localizeUnknownObject(value, language) {
  if (Array.isArray(value)) {
    return value.map((entry) => localizeValue(entry, language));
  }

  if (!value || typeof value !== 'object') {
    return translateLegacyContent(value, language);
  }

  return localizeEntity(value, language);
}

export function localizeValue(value, language = 'fr') {
  if (Array.isArray(value)) {
    return value.map((entry) => localizeValue(entry, language));
  }

  if (!value || typeof value !== 'object') {
    return translateLegacyValue(value, language);
  }

  return localizeUnknownObject(value, language);
}

export function localizeEntity(record, language = 'fr', fieldBases = DEFAULT_FIELD_BASES) {
  if (!record || typeof record !== 'object') return record;

  const localized = { ...record };

  fieldBases.forEach((baseField) => {
    const localizedValue = getLocalizedField(record, baseField, language);
    if (localizedValue != null && Object.prototype.hasOwnProperty.call(record, baseField)) {
      localized[baseField] = localizedValue;
    }
  });

  Object.keys(localized).forEach((key) => {
    const value = localized[key];

    if (Array.isArray(value)) {
      localized[key] = value.map((entry) => {
        if (typeof entry === 'string') return translateLegacyValue(entry, language);
        if (entry && typeof entry === 'object') return localizeEntity(entry, language, fieldBases);
        return entry;
      });
      return;
    }

    if (typeof value === 'string') {
      localized[key] = translateLegacyContent(value, language);
    }
  });

  return localized;
}

export function localizeCollection(items, language = 'fr', fieldBases = DEFAULT_FIELD_BASES) {
  if (!Array.isArray(items)) return [];
  return items.map((item) => localizeEntity(item, language, fieldBases));
}
